import React, { Component } from 'react'
import { Container, Header, Icon} from 'semantic-ui-react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Dashboard from './Dashboard'
import Login from './Login'
import NotFound from './NotFound'

class App extends Component {

  render () {
    return(
      <Container text>
          <Header as='h2' icon textAlign='center' color='grey'>
            <img src='https://liftsearch.co.za/images/logo.png' alt='Liftsearch logo' style={{width: '200px', height: '50px'}} />
            <Header.Content>
              Reports
            </Header.Content>
          </Header>
          <br/><br/>
          <Router>
            <Switch>
              <Route path='/' exact component={Dashboard} />
              <Route path='/login' exact component={Login} />
              <Route component={NotFound} />
            </Switch>
          </Router>
      </Container>
    )
  }
}

export default App
